<div
    class="menu-container"
    [class.collapsed]="collapsible() && isCollapsed()">
    @if (menu(); as menu) {
        <div class="d-flex">
            <menu-layout>
                <div class="d-flex flex-column w-100  h-60 my-auto">
                    @if(collapsible()){
                        <div class="mx-auto mb-5">
                            <chevron-left-icon
                                role="button"
                                (click)="toggleMenu(true)"
                                stop-click-bubble></chevron-left-icon>
                        </div>
                    }
                    @if(!isCollapsed()){
                        <presenter [data]="menu" />
                    }
                    @if(collapsible() && isCollapsed()){
                        <div
                        class="collapsed-trigger"
                        (click)="toggleMenu(false)"
                        stop-click-bubble>
                            <chevron-left-icon
                                class="right-arrow"
                            ></chevron-left-icon>
                        </div>
                    }
                    
                </div>
            </menu-layout>

            @if (!isCollapsed() && menu.subMenu(); as subMenu) {
                <presenter 
                    class="submenu" 
                    click-outside 
                    (onOutSideClick)="menu.toggleSubMenu(subMenu)" 
                    [allowFallback]="true" 
                    [@submenuAnimation] 
                    [data]="subMenu" 
                    key="subMenu"/>
            }
        </div>
    }
</div>
 